module.exports = __webpack_public_path__ + "static/media/Employee-Directory.36e5c6e8.png";